module.exports = __webpack_public_path__ + "static/img/play-video.7c7d403b.png";